import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=07351d8b&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=js"
export * from "./Culture.vue?vue&type=script&lang=js"
import style0 from "./Culture.vue?vue&type=style&index=0&id=07351d8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07351d8b",
  null
  
)

export default component.exports